<template>
  <section class="scratchcard-quantity-remaining flex items-center">
    <span v-if="quantityRemaining <= 0">
      {{
        $t('scratchcard.quantityremaining.max', {
          quantity: maxQuantity(availableCards),
        })
      }}
    </span>

    <i18n-t
      v-else
      data-testid="scratchcard-quantity-remaining-remaining-picks"
      keypath="scratchcard.quantityremaining.title"
      scope="global"
    >
      <template #quantity>
        <span
          :key="quantityRemaining"
          class="quantity flex items-center justify-center mx-100 bg-secondary-secondary-bold text-primary-primary rounded-l"
        >
          <strong>
            {{ quantityRemaining }}
          </strong>
        </span>
      </template>
    </i18n-t>
  </section>
</template>

<script lang="ts" setup>
import { useScratchcardStore } from '../stores/scratchcard'

const { availableCards, game } = useScratchcardGame()
const store = useScratchcardStore()
const { selectedQuantity } = storeToRefs(store)
const { maxQuantity } = store

const quantityRemaining = computed(() => {
  if (!game.value) return 0
  return maxQuantity(availableCards.value) - selectedQuantity.value
})
</script>

<style lang="scss" scoped>
.scratchcard-quantity-remaining {
  min-height: 1.5rem;

  .quantity {
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
